// Keep eTranslate above the header in its normal state and below theme
// drawers while they are open. The plugin's own styles use very high layers.
(() => {
  if (window.etranslateLayerFix?.observe) {
    window.etranslateLayerFix.observe();
    return;
  }

  const rootSelector = [
    '#etranslate-currency-selector-theme2',
    '#etranslate-language-float-selector-theme2',
    '#etranslate-language-float-link-selector-theme2',
    '#etranslate-language-embedded-selector-theme2',
    '#etranslate-language_currency-dropdown-selector-theme2',
    '#etranslate-language_currency-popup-selector-theme2',
  ].join(',');

  const layerSelector = [
    rootSelector,
    '.etranslate-currency-list-dropdown-box',
    '.etranslate-language-list-dropdown-box',
    '.etranslate-currency-list-dropdown',
    '.etranslate-language-list-dropdown',
  ].join(',');

  const themeLayerSelector = [
    'drawer-element[open]',
    '.drawer[open]',
    'modal-element[open]',
    'dialog[open]',
  ].join(',');

  const lockingLayerSelector = [
    'drawer-element[open]',
    '.drawer[open]',
    'x-modal[open]',
  ].join(',');

  const normalLayerIndex = '40';
  const modalLayerIndex = '0';
  let bodyObserver;
  let framePending = false;

  const setLayer = (element, value) => {
    if (
      element.style.getPropertyValue('z-index') === value &&
      element.style.getPropertyPriority('z-index') === 'important'
    ) {
      return;
    }

    element.style.setProperty('z-index', value, 'important');
  };

  const hasOpenThemeLayer = () => {
    if (!document.body) return false;

    return Boolean(document.querySelector(themeLayerSelector));
  };

  const syncBodyModalLock = () => {
    const body = document.body;
    if (!body) return;

    // Theme modal classes can remain stale when a custom drawer misses transitionend.
    const shouldLock = Boolean(document.querySelector(lockingLayerSelector));
    if (shouldLock) {
      body.classList.remove('has-modal-opening');
      body.classList.add('has-modal-open');
    } else {
      body.classList.remove('has-modal-opening', 'has-modal-open');
    }
  };

  const sync = () => {
    framePending = false;
    syncBodyModalLock();
    const layerIndex = hasOpenThemeLayer() ? modalLayerIndex : normalLayerIndex;

    document.querySelectorAll(layerSelector).forEach((element) => {
      setLayer(element, layerIndex);
    });
  };

  function scheduleSync() {
    if (framePending) return;

    framePending = true;
    window.requestAnimationFrame(sync);
  }

  document.addEventListener('drawer:afterShow', scheduleSync);
  document.addEventListener('drawer:afterHide', scheduleSync);
  document.addEventListener('toggle', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.matches('drawer-element, .drawer, x-modal, modal-element')) scheduleSync();
  });

  const observe = () => {
    if (!document.body) return;

    if (!bodyObserver) {
      bodyObserver = new MutationObserver(scheduleSync);
      bodyObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'open', 'active'],
        childList: true,
        subtree: true,
      });
    }

    scheduleSync();
  };

  window.etranslateLayerFix = { observe };
  observe();
})();
